module.exports = __webpack_public_path__ + "img/gift5-01-c1.af22666a.png";